import React from 'react';
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

function DialogModule(props) {
    const { title, children, open, setOpen, onConfirm, onDecline, yesButton = "Yes", noButton = "No", size = "sm", fullWidth = false, hideButtons= false } = props;
    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="confirm-dialog"
            maxWidth={size}
            fullWidth={fullWidth}
        >
            <DialogTitle id="confirm-dialog">
                {title}
                <IconButton className="float-right" onClick={() => {setOpen(false)}} style={{cursor:'pointer', float:'right', marginTop: '-8px', width: '20px'}}>
                    <CloseIcon  />
                </IconButton>
            </DialogTitle>
            <DialogContent>{children}</DialogContent>
            <DialogActions hidden={hideButtons}>
                <Button
                    variant="contained"
                    onClick={() => {
                        setOpen(false)
                        onDecline()
                    }}
                    color="secondary"
                >
                    {noButton}
                </Button>
                <Button
                    variant="contained"
                    onClick={() => {
                        setOpen(false);
                        onConfirm();
                    }}
                    // color="default"
                >
                    {yesButton}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default DialogModule;